import { render, staticRenderFns } from "./SetupViessmannSettingsWizardControl.global.vue?vue&type=template&id=8e63b892&lang=pug&"
import script from "./SetupViessmannSettingsWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./SetupViessmannSettingsWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports